import APIManager from "../shared/manager/APIManager";
import { RestEnds } from "../shared/Constants";
import AxiosManager from "shared/manager/AxiosManager";

const getPaymentStatus = async (id) => {
  return APIManager.sendGet(
    `${RestEnds.PAYMENT_STATUS}/${id}`,
    AxiosManager,
    true,
    {},
    {}
  );
};

const createPay = async (data) => {
  return APIManager.sendPatch(
    `${RestEnds.LOAN_PAY}`,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

const costCalculation = async (data) => {
  return APIManager.sendPatch(
    `${RestEnds.COST_CALCULATION}`,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

export const PaymentService = {
  getPaymentStatus,
  createPay,
  costCalculation,
};
